import React, { useContext, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CompanyContext } from 'contexts/CompanyContext';
import { MediaContext } from 'contexts/MediaContext';
import useDarkMode from 'utils/hooks/useDarkMode';
import { api as Api } from 'api/http';
import { HiOutlineFolder } from 'react-icons/hi';

const FolderChips = () => {
    const [isDarkMode] = useDarkMode();
    const { company } = useContext(CompanyContext);
    const { filtersMyMedia, setFiltersMyMedia } = useContext(MediaContext);
    const [folders, setFolders] = useState([]);

    useEffect(() => {
        if (!company?.id) return;
        Api.get(`/companies/${company.id}/folders?sort=name&page[size]=100`)
            .then(({ data }) => setFolders(data || []))
            .catch(() => {});
    }, [company?.id]);

    if (!folders?.length) return null;

    const activeFolderId = filtersMyMedia?.folder_id;

    const handleClick = (folderId) => {
        if (activeFolderId === folderId) {
            const next = { ...filtersMyMedia };
            delete next.folder_id;
            setFiltersMyMedia(next);
        } else {
            setFiltersMyMedia({ ...filtersMyMedia, folder_id: folderId });
        }
    };

    const handleClearAll = () => {
        const next = { ...filtersMyMedia };
        delete next.folder_id;
        setFiltersMyMedia(next);
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex items-center gap-2 overflow-x-auto pb-2 mb-3 scrollbar-hide"
        >
            {/* All chip */}
            <button
                onClick={handleClearAll}
                className={`shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all whitespace-nowrap
                    ${!activeFolderId
                        ? isDarkMode
                            ? 'bg-white/15 text-white'
                            : 'bg-gray-900 text-white'
                        : isDarkMode
                            ? 'bg-white/5 text-gray-400 hover:bg-white/10'
                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                    }
                `}
            >
                <HiOutlineFolder className="text-sm" />
                All
            </button>

            {folders.map((folder) => (
                <button
                    key={folder.id}
                    onClick={() => handleClick(folder.id)}
                    className={`shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all whitespace-nowrap
                        ${activeFolderId === folder.id
                            ? 'text-white shadow-md'
                            : isDarkMode
                                ? 'bg-white/5 text-gray-400 hover:bg-white/10'
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                        }
                    `}
                    style={activeFolderId === folder.id ? { backgroundColor: folder.color || '#3B82F6' } : {}}
                >
                    <div
                        className="w-2 h-2 rounded-full shrink-0"
                        style={{ backgroundColor: folder.color || '#3B82F6' }}
                    />
                    {folder.name}
                </button>
            ))}
        </motion.div>
    );
};

export default FolderChips;
